import axios from 'axios';
const endpoints = require('./endpoints.json');
const BASE_URL = endpoints.axiosScoringApi;

const axiosScoring = axios.create({
  baseURL: BASE_URL,
  timeout: 300000,
  headers: { 'Content-Type': 'application/json' },
});

axiosScoring.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Scoring API Error:', error);
    return Promise.reject(error);
  }
);

export default axiosScoring;
